import { ReactElement } from 'react'
import { ServiceCardLoader, PartnerCardLoader } from './ComponentsPlaceholder'
import { ContentLoaderProps } from './props'
import { StyledContentLoader } from './styles'

const ContentLoader = ({
    children,
    component,
    ...props
}: ContentLoaderProps): ReactElement => {
    const renderPlaceholder = () => {
        switch (component) {
            case 'ServiceCard':
                return <ServiceCardLoader />
            case 'PartnerCard':
                return <PartnerCardLoader />
            default:
                return children
        }
    }

    return (
        <StyledContentLoader {...props}>
            {renderPlaceholder()}
        </StyledContentLoader>
    )
}

export default ContentLoader

export { StyledContentLoader }
